import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
const Field = ({ label, prepend, error, name, isRequired, children }) => {
    const { t } = useTranslation();
    const requiredSymbol = isRequired ? '*' : '';
    return (_jsxs("div", { className: "form-group form-floating", children: [prepend && _jsx("span", { className: "form-control-prepend", children: prepend }), children, _jsx("label", { htmlFor: name, children: `${label}${requiredSymbol}` }), error && error.message && _jsx("div", { className: "invalid-feedback", children: t(error.message) })] }));
};
export default Field;
